<template>
<div>
        <b-navbar class="blogSpanHeader" toggleable="lg" type="dark" variant="dark" v-if="formatedTableValuesPreFilter">
           <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                     <b-navbar-brand class="ml-2">Hydrant ({{ formatedTableValues.length }})</b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav>
        <b-nav-form class="ml-2">
          <b-form-input class="ml-2 textInputSize" size="sm"  type="text" v-model="searchHydrant" placeholder="Hydrant Name"></b-form-input>
          <b-form-input class="ml-2 textInputSize" size="sm"  type="text" v-model="searchAddress" placeholder="Address"></b-form-input>
          <b-form-select  size="sm" class="ml-2" v-model="mapStatus" :disabled="disableMapStatus">
            <option value="both" >Map?</option>
            <option :value="true">True</option>
            <option :value="false">False</option>
          </b-form-select>
          <b-form-select  size="sm" class="ml-2" v-model="operableStatus">
            <option value="both" >Status?</option>
            <option :value="true">In Service</option>
            <option :value="false">Out of Service</option>
          </b-form-select>
        </b-nav-form>
              </b-navbar-nav>
                    </b-collapse>
          <b-navbar-nav class="ml-auto">
            <b-btn variant="outline-success"  size="sm" @click="dataViewMode == 'Map' ? (dataViewMode = 'Table', disableMapStatus = false, mapStatus = 'both') : (dataViewMode = 'Map', disableMapStatus = true, mapStatus = true)">{{ dataViewMode == 'Map' ? 'Table' : 'Map' }}</b-btn>
                      <b-btn variant="outline-info"  @click="FileProcess" v-if="dataViewMode == 'Table' && (userData.role == 'admin' || userData.role == 'adminchief')">Download</b-btn>
            </b-navbar-nav>

      </b-navbar>
     <b-table v-if="dataViewMode == 'Table'" :fields="fields" :items="formatedTableValues" :per-page="10" :current-page="currentPage"  stacked="lg">
        <template slot="hydrantLocalId" slot-scope="data">
          <h5 class="mb-0"><b-badge :variant="getHydrantClass(data.item.hydrantOperable, data.item.hydrantGpm)">{{ data.item.hydrantLocalId }}</b-badge></h5>
        </template>
        <template slot="hydrantGpm" slot-scope="data">
          {{ Math.floor(data.item.hydrantGpm) }}
        </template>
        <template slot="hydrantLastInspection" slot-scope="data">
          <span>{{ getDateFormat(data.item.hydrantLastInspection)}}</span>
        </template>
        <template slot="inspection" slot-scope="data">
          <b-btn variant="outline-success" size="sm" @click="addInspectionId = data.item.id">New Inspection</b-btn>
        </template>
        <template slot="Operable" slot-scope="data">
          {{ data.item.Operable }}
        </template>
        <template slot="view" slot-scope="data">
          <b-btn variant="outline-info" size="sm" @click='emitItem(data.item.id)'>View</b-btn>
        </template>
        <template slot="Remove" slot-scope="data">
          <b-btn variant="outline-danger" v-if="userData.role == 'admin'" :disabled="false" size="sm" @click='deleteItem(data.item.id)'>Delete</b-btn>
        </template>
              </b-table>
       <b-pagination class="pt-2" align="center" size="md" v-if="formatedTableValues && dataViewMode == 'Table'" :total-rows="formatedTableValues.length" v-model="currentPage" :per-page="10" />
      <hydrantMap v-if="dataViewMode == 'Map'" :responseView="false" :availableBusiness="formatedTableValues" @showHydrant="emitItem($event)" />
      <addNewHydrantInspection v-if="addInspectionId" :hydrantId="addInspectionId" @emitCloseHydrant="addInspectionId = null, removeBodyTag()" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { bus } from '../../../main'
import axios from 'axios'
import printJS from 'print-js'
import DatePicker from '../../inputfields/Datepickermod.vue'
import TimePicker from '../../inputfields/timepicker.vue'
import moment from 'moment'
import Leaf from 'leaflet'
import addNewHydrantInspection from '../../addNew/addNewHydrantInspection.vue'
import hydrantMap from './hydrantMaps.vue'
import PapaParse from 'papaparse';
import querystring  from 'querystring';
import Multiselect from 'vue-multiselect'
import arrayData from '../../../../files/dispatchReport.js'
import convert from 'xml-js'
export default {
  props:["formTableStyle", "formGroups", "submittedHydrant"], 
components:{
      'hydrantMap' : hydrantMap,
      'timepicker' : TimePicker,
      'multiselect' : Multiselect,
      'datepicker' : DatePicker,
      addNewHydrantInspection
},
  data () {
    return {
        showTutVideo: false,
        edit: true,
        imageResponseData: [],
        postData: '',
        timeData: '',
        imageSrc: '',
        searchGrid: '',
        searchHydrant: '',
        searchStation: '',
        searchAddress: '',
        currentPage: 1,
        stationSelectValue: '',
        showGroup: 'hydrant',
        showModalConfirmation: false,
        pictureUpload: '',
        searchData: '',
        sortOrder: 'asc',
        carouselToggle: '',
        pictureFileArray: [],
        imageLoader: '',
        holdValues: {},
        addInspectionId: null,
        patchData: false,
        completedLoad: false,
        ppObj: {},
        fields: [],
        tableRows: [],
        formatedTableValuesPreFilter: [],
        jsonArray: [],
        buildData: [],
        mapStatus: 'both',
        operableStatus: 'both',
        disableMapStatus: false,
        disableOperableStatus: false,
        dataViewMode: 'Table',
        sortBySelected: true,

    }
  },
  created(){
  var data = arrayData.arrayData
  var jsonArray = []
  for(var i in data){
    var result = convert.xml2json(data[i], {compact: true, spaces: 0})
    var parsed = JSON.parse(result)
    jsonArray.push(parsed)
  }
    this.buildData = []
   this.jsonArray = jsonArray
  },
  mounted(){
    var data = _.cloneDeep(this.submittedHydrant)
    this.buildTableData(this.formTableStyle, data)
    this.setupTableValues(this.formTableStyle, data)
  
  },
  computed:{
    ...mapState([
          'getSessionData',
          'stationsData',
          'apparatusData',
          'userData',
          'shiftsData',
          'Hydranttatus',
        ]),
        formatedTableValues(){
          if(this.searchGrid){
          var grid = this.formatedTableValuesPreFilter.filter(p => {
                  if(this.searchGrid){ 
                  return p.gridNumber.toString().match(this.searchGrid.toString())
                  } else {
                    return p
                  }
          })
        } else { var grid = this.formatedTableValuesPreFilter }
        if(this.searchStation){
          var station = grid.filter(p => {
            return  p.primaryStation.includes(this.searchStation)
          })
         } else { var station = grid }
          if(this.searchHydrant){
           var hydrant = station.filter(p => {
             if(this.sortBySelected){
               var searchOpt = this.searchHydrant.toLowerCase().split(' ')
               var searchResult = true
               for(var i in searchOpt){
                 var index = p.hydrantLocalId.toLowerCase().includes(searchOpt[i])
                   if(!index){
                     searchResult = false
                   }
                 }
                 if(searchResult){
                   return p
                 }
               
             } else {
                return p.hydrantLocalId.toLowerCase().includes(this.searchHydrant.toLowerCase()) 
             }
           })
         } else { var hydrant = station   }
         var map = hydrant.filter(p => {
                 if(this.mapStatus == false){

                    if(!p.map){
                      return p
                    }
                  } else if (this.mapStatus == true){
                    if(p.map){
                      return p
                    }
                  } else {
                    return p
                  }
         })
         var map = map.filter(p => {
              if(this.operableStatus == false){


                    if(!p.hydrantOperable){
                      return p
                    }
                  }
                    else if(this.operableStatus == true){
                    if(p.hydrantOperable){
                      return p
                    }
                  }
                   else {
                    return p
                  }
         })
         if(this.searchAddress){
           var address = map.filter(p => {
             if(this.sortBySelected){
               var searchOpt = this.searchAddress.toLowerCase().split(' ')
               var searchResult = true
               for(var i in searchOpt){
                 var index = p.streetNumberStreetStreetSuffix.toLowerCase().includes(searchOpt[i])
                   if(!index){
                     searchResult = false
                   }
                 }
                 if(searchResult){
                   return p
                 }
               
             } else {
                return p.streetNumberStreetStreetSuffix.toLowerCase().includes(this.searchAddress.toLowerCase()) 
             }
           })
         } else {
           var address = map
         }
         return _.orderBy(address, ['hydrantLastInspection'], ['asc'])
        },
    
    

    },
  methods:{
    removeBodyTag(){
       console.log('body class removed')
       document.body.classList.remove('modal-open');
       this.$emit('getHydrants')
    },
    getHydrantClass(avail, gpm){
      var color = avail && gpm > 1500 ? 'primary' : avail && (gpm > 1000 && gpm < 1500) ? 'success' : avail && (gpm > 500 && gpm < 1000) ? 'orange' : avail && gpm ? 'danger' : 'dark'
      return color
    },
    getDateFormat(data){
     // console.log(data)
      if(data){
        return moment(data).fromNow()
      } else {
        return 'invalid'
      }
    },
    getDateFormatTitle(data, author){
      if(data){
        var time = moment(data).format('MM/DD/YYYY HH:mm')
        return 'Last Updated on ' + time + ' by ' + author
      } else {
        return 'invalid'
      }
    },
    buildTableData(table, data){
      for(var i in table){
        var obj = {key: table[i].key, label: table[i].label}
        this.fields.push(obj)
      }
      this.fields.push({key: 'hydrantGpm', label: 'GPM'})
      this.fields.push({key: 'hydrantLastInspection', label: 'Last Inspection'})
      this.fields.push({key: 'hydrantOperable', label: 'In Service'})
      this.fields.push({key: 'inspection', label: 'Add Inspection'})
      //this.fields.push('map')
      var edit = 'view'
      this.fields.push(edit)
      if(this.userData.role == 'admin'){
        this.fields.push('Remove')
      }
     
    },
        setupTableValuesLoop(obj, vals){
        for(var p in vals){
          if(vals[p].key != 'map'){
          obj[vals[p].key] = vals[p].value
          } else if (vals[p].key == 'map'){
            obj[vals[p].key] = vals[p]
          }
        }  
      return obj
    },
    setupTableValues(table, data){
      var newArray = this.buildData
      for(var i in data){
        var obj = data[i]
        var vals = obj.hydrantTableData
        for(var p in vals){
          if(vals[p].key != 'map'){
          obj[vals[p].key] = vals[p].value
          } else if (vals[p].key == 'map'){
            obj[vals[p].key] = vals[p]
          }

        }     
        newArray.push(obj)
      }
   //   newArray.forEach(item => item.map = this.getItemMap(item.map))
   //   var holdnewArray = newArray
      this.formatedTableValuesPreFilter = newArray
    },
    setupTableValuesback(table, data){
      var hydrantPar = [...new Set(dataArray.map(p => p.hydrantParent))]
      hydrantPar = hydrantPar.filter(p => p != null && p != undefined)
      var data = dataArray.filter(p => !p.hydrantParent)
      var newArray = this.buildData
      for(var i in data){
        var obj = data[i]
        var vals = obj.hydrantTableData
        for(var p in vals){
          if(vals[p].key != 'map'){
          obj[vals[p].key] = vals[p].value
          } else if (vals[p].key == 'map'){
            obj[vals[p].key] = vals[p]
          }

        }     
        newArray.push(obj)
      }
   //   newArray.forEach(item => item.map = this.getItemMap(item.map))
   //   var holdnewArray = newArray
      this.formatedTableValuesPreFilter = newArray
    },
    getItemMap(item){
      if(!item){
          var southWest= {lat: 27.128813241669747, lng: -82.99415588378908}
          var northEast = {lat: 27.54480631775389, lng: -82.03765869140626}
          var lngSpan = northEast.lng - southWest.lng
          var latSpan = northEast.lat - southWest.lat
          return {obj: {y: southWest.lat + latSpan * Math.random(), x: southWest.lng + lngSpan * Math.random()}}
      } else {
        return item
      }
    },
    emitItem(data){
      console.log('data')
      var obj = this.submittedHydrant.find(p => p.id == data)
      this.$emit('showhydrant', obj)
    },
    deleteItem(data){
      this.$emit('deletehydrant', data)
    },
    getTableItems(display, fields){
      var fieldSort = fields.filter(p => p.order == display)
       var obj = {}
      for(var i in fieldSort){
        var key = fieldSort[i].idtag
        var value = this.holdValues[fieldSort[i].vmodel].value
        if(value == undefined){
          value = 'Not Entered'
        }
        if(fieldSort[i].type == 'computed'){
          value = this.getComputedValues(fieldSort[i])
        }
        if(fieldSort[i].type == 'taxonomySingleSelect'){
          value = this.holdValues[fieldSort[i].vmodel].value[fieldSort[i].taxitem]
        }
        if(fieldSort[i].type == 'reference'){
          value = this.holdValues[fieldSort[i].reference].value[fieldSort[i].refitem]
        }
        obj[key] = value
      }
    var arr = []
    arr.push(obj)
    return arr
    },
    getComputedValues(data){
      var array = []
      for(var i in data.ref){
        var hold = this.holdValues[data.ref[i]].value
        if(hold != undefined && hold != null && hold != ''){
          array.push(hold)
        }
      }
      var operator = function(a, b){ return a * b}
      var holdValue = 0
      for(var i in array){
        if(i == 0){
          var item = operator(array[i], array[1])

          holdValue = item
        } else if(i > 1) {
           var item = operator(holdValue, array[i]) 
        }
      }
      return holdValue
    },
    FileProcess(){
        var json_data = _.cloneDeep(this.formatedTableValues)

        json_data = json_data.map(p => {
            var table = p.hydrantTableData
            var obj = p
            delete obj.id
            for(var k in table){
              if(table[k].key != 'map'){
                obj[table[k].key] = table[k].value
              }
              
            }
            delete obj.hydrantTableData
            delete obj.map
            return obj
        })
        const fileName = 'hydrant-data' + moment().format('YYYY-MM-DD-HHmm') + '.csv';
        const data = PapaParse.unparse(json_data)
        var csvData = new Blob([data], {type: 'text/csv;charset=utf-8;'});
        var csvURL =  null;
        if (navigator.msSaveBlob)
        {
            csvURL = navigator.msSaveBlob(csvData, fileName);
        }
        else
        {
            csvURL = window.URL.createObjectURL(csvData);
        }
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = csvURL;
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
      },

    getDescendantProp(obj, desc) {
    var arr = desc.split(".");
    while(arr.length && (obj = obj[arr.shift()]));
    return obj;
    },


}
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.badge-orange {
    color: #fff;
    background-color: #fd7e14;
}
.A-shift {
    background: #fff;
  color: #e2070d;
}
.B-shift {
    background: #fff;
  color: #201B9F;
}
.C-shift {
    background: #fff;
  color: #0FB906;
}
.multiselect__option--highlight {
  background: #f0454a
}
span.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 10px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #f0454a;
  margin-bottom: 8px;
  white-space: nowrap;
}
span.custom__remove {
  color: #444;
  font-weight: bold;
  margin-left: 3px;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style scoped>
.numberInputSize {
  width: 70px;
}
.textInputSize {
  width: 140px;
}
.textAreaDescription {
  margin-top: 10px;
}
span{
  margin-bottom: 10px;
}
.multiselect{
  margin-bottom: 15px;
}
.itemDescription {
  margin-top: 10px;
  border-style: solid;
    border: 1px solid #bbb;
}
#tablePassDown{
  margin: 0;
  padding: 0;
}
.sub-section-heading {
color: White;
background: #aaa;
width: 100%;
border-radius: 5px;
padding: 7px;
text-align: center;
margin-top: 10px;
margin-bottom: 10px;
margin-right: 0;
margin-left: 0;
}
textarea {
  width: 100%;
  border-radius: 5px;
}
.centerTheHeading {
  text-align: center;
}
.genLeft h3 {
  margin-right: 30px;
  text-align: right;
}
.genCenter {
  text-align: center;
}
.removeButton {
  background: white;
  color: red;
  border: 1px solid red;
  border-radius: 50%;
  margin: 0;
}
input {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
}
span.defDescrip {
  border: 1px solid red;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  margin-left: 40px;
}
span.Yes {
  background: green;
  color: white;
  padding: 3px;
}
span.No {
  background: red;
  color: white;
  padding: 3px;
}
table {
  width: 100%;
  text-align: center;
}
tr.headerRows {
  background: #aaa;
  font-weight: bold;
}
#confirmationTable td {
    padding: 5px;

}
.selectedButtonGreen {
  background: green;
  color: white;
}
.selectedButtonRed {
  background: red;
  color: white;
}
#todaysDateDisplay {
  margin-bottom: 0;
  cursor: pointer;
  color: red;
}
#logbookBody {
  margin-top: 60px;
  width: 100%;
}
.addNewArticle {
  border-radius: 50%;

}
.addNewArticle:hover {
  background: grey;
}
.timeMobile{
  display: none;
}
@media screen and (max-width: 920px) {
  .time-picker.timeDesk{
    display: none;
  }
  .timeMobile{
    display: block;
    min-width: 120px;
    max-width: 150px;
  }
}


</style>
